export var RESPONSE_DEADLINE_SITUATIONS = [
    {
        name: 'firstVisitStartedOnPeriod',
        translation: 'MAINTENANCES.FILTERS.NOT_DELAYED',
        value: true,
        status: 'not-delayed',
        icon: 'assignment_turned_in'
    },
    {
        name: 'firstVisitStartedOutPeriod',
        translation: 'MAINTENANCES.FILTERS.DELAYED',
        value: false,
        status: 'first-visit-delayed',
        icon: 'assignment_late'
    }
];
export var COMPLETE_DEADLINE_SITUATIONS = [
    {
        name: 'closedOnPeriod',
        translation: 'MAINTENANCES.FILTERS.NOT_DELAYED',
        value: true,
        status: 'not-delayed',
        icon: 'assignment_turned_in'
    },
    {
        name: 'closedOutPeriod',
        translation: 'MAINTENANCES.FILTERS.DELAYED',
        value: false,
        status: 'close-delayed',
        icon: 'assignment_late'
    },
];
export var STATUS = [
    {
        name: 'new',
        translation: 'MAINTENANCES.STATUS_OPTIONS.NEW',
        icon: 'icon-plus-circle-outline',
        color: '#8ec942'
    },
    {
        name: 'requested',
        translation: 'MAINTENANCES.STATUS_OPTIONS.REQUESTED',
        icon: 'icon-email',
        color: '#1a409e'
    },
    {
        name: 'onNegotiation',
        translation: 'MAINTENANCES.STATUS_OPTIONS.ON_NEGOTIATION',
        icon: 'assignment_late',
        isMaterialIcon: true,
        color: '#606060'
    },
    {
        name: 'pending',
        translation: 'MAINTENANCES.STATUS_OPTIONS.PENDING',
        icon: 'icon-calendar-clock',
        color: '#3d99e9'
    },
    {
        name: 'scheduled',
        translation: 'MAINTENANCES.STATUS_OPTIONS.SCHEDULED',
        icon: 'icon-clock',
        color: '#105bfb'
    },
    {
        name: 'inProgress',
        translation: 'MAINTENANCES.STATUS_OPTIONS.IN_PROGRESS',
        icon: 'icon-map-marker',
        color: '#e4771f'
    },
    {
        name: 'done',
        translation: 'MAINTENANCES.STATUS_OPTIONS.DONE',
        icon: 'icon-check',
        color: '#12B886'
    },
    {
        name: 'canceled',
        translation: 'MAINTENANCES.STATUS_OPTIONS.CANCELED',
        icon: 'icon-close',
        color: '#c25ab5'
    },
    {
        name: 'reported',
        translation: 'MAINTENANCES.STATUS_OPTIONS.REPORTED',
        icon: 'icon-alert',
        color: '#f85457'
    }
];
export var STATUS_APPROVALS = [
    {
        name: 'pending',
        translation: 'APPROVALS_EQUIPMENTS.STATUS_OPTIONS.PENDING',
        icon: 'icon-clock'
    },
    {
        name: 'approved',
        translation: 'APPROVALS_EQUIPMENTS.STATUS_OPTIONS.APPROVED',
        icon: 'icon-check'
    },
    {
        name: 'refused',
        translation: 'APPROVALS_EQUIPMENTS.STATUS_OPTIONS.REFUSED',
        icon: 'icon-alert'
    },
    {
        name: 'canceled',
        translation: 'APPROVALS_EQUIPMENTS.STATUS_OPTIONS.CANCELED',
        icon: 'icon-close'
    }
];
export var WARRANTY_STATUS = [
    {
        name: 'active',
    },
    {
        name: 'extended',
    },
    {
        name: 'expired',
    },
    {
        name: 'future',
    }
];
export var INTERVAL = [
    {
        name: 'RECURRENCES.FILTER.INTERVAL.DAILY',
        value: 'daily',
        id: 0
    },
    {
        name: 'RECURRENCES.FILTER.INTERVAL.WEEKLY',
        value: 'weekly',
        id: 1
    },
    {
        name: 'RECURRENCES.FILTER.INTERVAL.MONTHLY',
        value: 'monthly',
        id: 2
    }
];
export var TASKS_STATUS = [
    {
        name: 'pending',
        icon: 'icon-clock',
        translate: 'PENDING'
    },
    {
        name: 'scheduled',
        icon: 'icon-calendar-clock',
        translate: 'SCHEDULED'
    },
    {
        name: 'onRoute',
        icon: 'icon-truck',
        translate: 'ON_ROUTE'
    },
    {
        name: 'inProgress',
        icon: 'icon-map-marker',
        translate: 'IN_PROGRESS'
    },
    {
        name: 'done',
        icon: 'icon-check-circle',
        translate: 'COMPLETED'
    },
    {
        name: 'reported',
        icon: 'icon-alert',
        translate: 'REPORTED'
    },
    {
        name: 'canceled',
        icon: 'icon-close-circle-outline',
        translate: 'CANCELED'
    },
];
export var QUOTATION_STATUS = [
    {
        name: 'pending',
        icon: 'icon-clock',
        translate: 'PENDING'
    },
    {
        name: 'approved',
        icon: 'icon-check-circle',
        translate: 'APPROVED'
    },
    {
        name: 'refused',
        icon: 'icon-alert',
        translate: 'REFUSED'
    },
    {
        name: 'expired',
        icon: 'icon-clock',
        translate: 'EXPIRED'
    },
    {
        name: 'canceled',
        icon: 'icon-close-circle-outline',
        translate: 'CANCELED'
    },
];
export var PRODUCT_SERVICE_TYPE = [
    {
        name: 'product',
        icon: 'icon-clock',
        translate: 'PRODUCT'
    },
    {
        name: 'SERVICE',
        icon: 'icon-check-circle',
        translate: 'SERVICE'
    },
];
export var FORM_CONDITION_OPERATORS = [
    {
        name: 'equal',
        translate: 'FORMS.DIALOGS.TABS.GENERAL.QUESTIONS.CONDITIONS.OPERATORS.EQUAL'
    },
    {
        name: 'notEqual',
        translate: 'FORMS.DIALOGS.TABS.GENERAL.QUESTIONS.CONDITIONS.OPERATORS.NOT_EQUAL'
    }
];
export var RATINGS = [
    { value: null, translation: 'NO_RATING' },
    { value: 1, translation: 'TERRIBLE' },
    { value: 2, translation: 'BAD' },
    { value: 3, translation: 'REGULAR' },
    { value: 4, translation: 'GOOD' },
    { value: 5, translation: 'GREAT' }
];
var ɵ0 = function (status) { return status.name; };
export var ALL_STATUS_NAMES = STATUS.map(ɵ0);
var ɵ1 = function (status) { return status !== 'canceled'; };
export var STATUS_NAMES_EXCEPT_CANCELED = ALL_STATUS_NAMES.filter(ɵ1);
var ɵ2 = function (status) { return status !== 'done'; };
export var STATUS_NAMES_EXCEPT_CANCELED_AND_DONE = STATUS_NAMES_EXCEPT_CANCELED.filter(ɵ2);
var ɵ3 = function (status) { return status === 'done'; };
export var STATUS_NAMES_DONE = ALL_STATUS_NAMES.filter(ɵ3);
export var TWO_MINUTES_IN_MILLIS = 60 * 2 * 1000;
export var SECTOR_AND_ENVIRONMENT_ROLLOVER_DATE = new Date('2024-06-20T12:00:00Z');
export { ɵ0, ɵ1, ɵ2, ɵ3 };
